export default __webpack_public_path__ + "static/media/comment.4df26194.svg";